import { Directive, ElementRef, Input, OnInit, OnDestroy, inject } from '@angular/core';

@Directive({
  selector: '[cnReveal]',
  standalone: true,
  host: { class: 'reveal' },
})
export class ScrollRevealDirective implements OnInit, OnDestroy {
  @Input('cnRevealDelay') delay?: string;

  private el = inject(ElementRef);
  private observer?: IntersectionObserver;

  ngOnInit() {
    const native: HTMLElement = this.el.nativeElement;
    if (this.delay) native.setAttribute('data-d', this.delay);

    if (!('IntersectionObserver' in window)) {
      native.classList.add('in');
      return;
    }

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            this.observer?.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -4% 0px' },
    );
    // Defer until after layout paint so elements have real dimensions
    requestAnimationFrame(() => {
      if (this.observer) this.observer.observe(native);
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
